module.exports = __webpack_public_path__ + "img/v36.43c811e0.jpg";